import React from "react";
import { BiLink } from "react-icons/bi";
import styled from "styled-components";


// import Fade from 'react-reveal/Fade';

function MyProject() {



  const NewProject = styled.section`

  .box-project
  {
    margin:25px
  }
  .projectnewbox
  {
    ${'' /* border:2px solid #00A2E7; */}
    width:350px;
    height:300px;
   
  }
  .p-color
  {
    background-color:#00a2e7;
    padding:5px;
    color:white
  }

  .p-color {
  --borderWidth: 3px;
  position: relative;
  ${'' /* border-radius: var(--borderWidth); */}
}
.p-color:after {
  content: '';
  position: absolute;
  top: calc(-1 * var(--borderWidth));
  left: calc(-1 * var(--borderWidth));
  height: calc(100% + var(--borderWidth) * 2);
  width: calc(100% + var(--borderWidth) * 2);
  background: linear-gradient(60deg, #f79533, #f37055, #ef4e7b, #a166ab, #5073b8, #1098ad, #07b39b, #6fba82);
  border-radius: calc(2 * var(--borderWidth));
  z-index: -1;
  animation: animatedgradient 3s ease alternate infinite;
  background-size: 300% 300%;
}



  .img-box img
  {
    width:350px;
    height:250px;
    border-radius: 3px 3px 0px 0px;


  }
  .img-box img:hover
  {
    width:100%;
    height:250px;
    transition: 0.3s ease-in-out;
  }
  .projectText
  {
    background-color:#00A2E7;
    display:flex;
    justify-content:space-between;
    align-items:center;
    width:350px;
    
  
  }
  .projectText {
  --borderWidth: 3px;
  position: relative;
  ${'' /* border-radius: var(--borderWidth); */}
}
.projectText:after {
  content: '';
  position: absolute;
  top: calc(-1 * var(--borderWidth));
  left: calc(-1 * var(--borderWidth));
  height: calc(100% + var(--borderWidth) * 2);
  width: calc(100% + var(--borderWidth) * 2);
  background: linear-gradient(60deg, #f79533, #f37055, #ef4e7b, #a166ab, #5073b8, #1098ad, #07b39b, #6fba82);
  border-radius: calc(2 * var(--borderWidth));
  z-index: -1;
  animation: animatedgradient 3s ease alternate infinite;
  background-size: 300% 300%;
}
 
 

  .project-button
  {
    width:350px;
    padding-left:10px;
    padding-top:10px;
    transition: 0.3s ease-in-out;

  }
  .project-button:hover
  {
    
    padding-left:0px;
    padding-top:0px;
    transition: 0.3s ease-in-out;
 

  }
.text 
{
  display:flex;
    justify-content:center;
    align-items:center;
    font-size:20px;
    text-wrap:wrap;
    padding:10px;
    color:#fff
}  




.icon
{ display:flex;
    justify-content:center;
    align-items:center;
    font-size:30px;
    padding:10px;
    color:#fff
}




.projectnewbox {
  --borderWidth: 3px;
  background:#091B2A;
  position: relative;
  ${'' /* border-radius: var(--borderWidth); */}
}
.projectnewbox:after {
  content: '';
  position: absolute;
  top: calc(-1 * var(--borderWidth));
  left: calc(-1 * var(--borderWidth));
  height: calc(100% + var(--borderWidth) * 2);
  width: calc(100% + var(--borderWidth) * 2);
  background: linear-gradient(60deg, #f79533, #f37055, #ef4e7b, #a166ab, #5073b8, #1098ad, #07b39b, #6fba82);
  border-radius: calc(2 * var(--borderWidth));
  z-index: -1;
  animation: animatedgradient 3s ease alternate infinite;
  background-size: 300% 300%;
}


@keyframes animatedgradient {
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
}


@media only screen and (max-width: 767px) {

  .img-box img {
    width: 350px;

}


  `
  const projectDetail = [

    { 
      DOM:"May 2024",
      title:"Restraunt Animated",
      backImage: "./images/restraunt.png",
      webSite: "https://hakanoodle.netlify.app/",
    },
    { 
      DOM:"April 2024",
      title:"Web Services Website",
      backImage: "./images/100xweb.png",
      webSite: "https://100xweb.netlify.app/",
    },
    
    { 
      DOM:"Dec 2023",
      title:"Portfolio Website",
      backImage: "./images/abhi.png",
      webSite: "https://abhinawdev.netlify.app/",
    },
    {
      DOM:"Oct 2023",
      title:"Blog Website",
      backImage: "./images/blog.png",
      webSite: "https://abhinawblog.netlify.app/",
    },
    {
      DOM:"May 2023",
      title:"Simple Portfolio Website",
      backImage: "./images/portfolio.png",
      webSite: "https://abhinawdeonath.netlify.app/",
    },
    {
      DOM:"April 2023",
      title:"Zip Converter Website",
      backImage: "./images/zip.png",
      webSite: "https://zipconverter.netlify.app/",
    },
  
   
   
  ];
  return (
    <>


      {projectDetail.map((items, i) => (
      <NewProject>
      <div className="box-project">
      <h4 > <span className="p-color">{items.DOM}</span> </h4>
      <a href={items.webSite}>
      <div className="projectnewbox">
      <div className="project-button">
      
       <div className="img-box"><img src={items.backImage} alt="" />
        </div>
      
        <div className="projectText">
          <div className="text">
          <h4>{items.title}</h4>
          </div>
          <div className="icon"> <BiLink className="link-view" /></div>
        </div>
        </div>
        
     

      </div>

      </a>
      </div>
      </NewProject>
    ))}
          
    </>
  );
}

export default MyProject;
